import React, { Component } from "react";
import logo from "../logo.svg";
import { Link, animateScroll as scroll } from "react-scroll";




class Navbar extends Component {
  constructor() {
    super();

    this.banner = React.createRef();
    this.bannerbg = React.createRef();
    this.bannerClose = this.bannerClose.bind(this);

  }
  componentDidMount() {
    // setTimeout(() => {
    //   this.banner.current.classList.remove('new-year-close');
    //   this.bannerbg.current.classList.remove('bg-2026-close');

    // }, 2000)

  }
  bannerClose(event) {
    this.banner.current.classList.add('new-year-close');
    this.bannerbg.current.classList.add('bg-2026-close');
  }

  scrollToTop() {
    scroll.scrollToTop();
  }

  render() {
    let iter = true;
    let menu = 0;


    document.addEventListener('wheel', function (event) {
      let delta = event.deltaY || event.detail || event.wheelDelta;
      if (delta > 5 && iter === true) {
        menu = document.querySelectorAll('.menu-top span .scrol');
        menu.forEach(element => {
          if (element.classList.contains("active")) {
            if (element.nextElementSibling) {
              if (element.nextElementSibling.classList.contains("scrol")) {
                element.nextElementSibling.click();
              }
            }
          }
        });
        iter = false;
        setTimeout(function () { iter = true }, 1500)
      } if (delta < -3 && iter === true) {
        menu = document.querySelectorAll('.menu-top span .scrol');
        menu.forEach(element => {
          if (element.classList.contains("active")) {
            if (element.previousSibling) {
              if (element.previousSibling.classList.contains("scrol")) {
                element.previousSibling.click();
              }
            }
          }
        });
        iter = false;
        setTimeout(function () { iter = true }, 1500)
      }

    });

    let last;
    document.addEventListener('touchmove', function (e) {

      let current = e.originalEvent.touches[0].clientY;
      if (current > last) {
        menu = document.querySelectorAll('.menu-top span .scrol');
        menu.forEach(element => {
          if (element.classList.contains("active")) {
            if (element.nextElementSibling) {
              if (element.nextElementSibling.classList.contains("scrol")) {
                element.nextElementSibling.click();
              }
            }
          }
        });
        iter = false;
        setTimeout(function () { iter = true }, 1500)

        // Движение пальцем вниз
      } else if (current < last) {

        menu = document.querySelectorAll('.menu-top span .scrol');
        menu.forEach(element => {
          if (element.classList.contains("active")) {
            if (element.previousSibling) {
              if (element.previousSibling.classList.contains("scrol")) {
                element.previousSibling.click();
              }
            }
          }
        });
        iter = false;
        setTimeout(function () { iter = true }, 1500)
        // Движение пальцем вверх
      }
      last = current;
    });

    setTimeout(() => function () {
      document.querySelector('.new-year').classList.remove('new-year-close');
    }, 1000);


    return (
      <nav className="nav" id="navbar">
        <div className="nav-content">
          <a className='logo' href="/">
            <img src={logo} alt="логотип УДС" />
          </a>
          <div className='info_box'>
            <div className='info'>
              <a href='tel:+74965000381'>+7 (496) 500 03 81</a>
              <a href='tel:+79165153512'>+7 (916) 515 35 12</a>
              <a className='mail' href='mailto:'>press@agro-pak.ru</a>
            </div>
            <nav className='menu-top '>

              <span>

                <Link
                  className="scrol"
                  to="section1"
                  spy={true}
                  smooth={true}
                  delay={300}
                  offset={-90}
                  duration={600}>главная</Link>



                <Link
                  className="scrol prodacts"
                  to="containerElement"
                  spy={true}
                  smooth={true}
                  delay={300}
                  offset={-90}
                  duration={600}>продукция</Link>



                <Link
                  className="scrol"
                  to="section3"
                  spy={true}
                  smooth={true}
                  delay={300}
                  offset={-90}

                  duration={600}>
                  о компании
                </Link>


                <Link
                  className="scrol"
                  to="section4"
                  spy={true}
                  smooth={true}
                  delay={300}
                  offset={-90}

                  duration={600}
                >вопрос ответ</Link>



                <Link
                  className="scrol"
                  to="section5"
                  spy={true}
                  smooth={true}
                  delay={300}
                  offset={-90}

                  duration={600}
                >контакты
                </Link>


                <a href="https://agro-foto.ru/" rel="noreferrer" target={'_blank'} >слайдотека агро-фото</a>
                <a href="http://gallery.tekpolska.pl/" rel="noreferrer"  >слайдотека ТЕК</a>
              </span>
            </nav>
          </div>

        </div>
        <div ref={this.bannerbg} onClick={this.bannerClose} className="bg-2026 bg-2026-close"></div>
        <div ref={this.banner} className="new-year new-year-close">
          <div onClick={this.bannerClose} className="close">x</div>
        </div>
      </nav>
    );
  }
}
export default Navbar;
